import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

@Injectable()
export class Footer {
  onUpdated: Subject<FooterOptions> = new Subject<FooterOptions>();
  onActionClicked: Subject<boolean> = new Subject<boolean>();

  update(options: FooterOptions) {
    this.onUpdated.next(options);
  }
}

export class FooterOptions {
  title: string;
  action?: string | (() => void) = null;
  externalLink?: boolean = null;
  alignLeft?: boolean = null;
}



// WEBPACK FOOTER //
// ./src/app/services/footer.service.ts